import { useEffect } from 'react'
import { Label } from './ui/label'
import { FiRotateCcw } from 'react-icons/fi'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select'
import { useTracks } from '../context/audio-provider'

import { useSkin } from '../context/skin-provider'
import { musicalKeyOptions } from '../lib/utils'
import { useLooper } from '../context/looper-provider'

const KeySelector = () => {
  const disableKeySelector = true
  const { skin } = useSkin()

  const { key, currentKey, setCurrentKey } = useLooper()
  const { updateKey } = useTracks()

  useEffect(() => {
    if (currentKey && key) updateKey(key, currentKey)
  }, [key, currentKey, updateKey])

  const resetKey = () => {
    if (key) setCurrentKey(key)
  }

  const inputValue = currentKey ? currentKey : key

  return (
    <div className="flex w-full flex-col items-center gap-2">
      <div className="flex w-[60%]">
        <Label className="text-left" htmlFor="key">
          Key
        </Label>
      </div>
      <div className="flex w-[60%] items-center justify-between">
        {disableKeySelector ? (
          <p className="text-sm">This feature is temporarily unavailable</p>
        ) : (
          <Select value={inputValue} onValueChange={(value) => setCurrentKey(value)}>
            <SelectTrigger
              title="Set Key"
              className="w-full"
              style={{
                backgroundColor: skin.bgColor,
                color: skin.textColor
              }}
            >
              <SelectValue placeholder="Theme" />
            </SelectTrigger>
            <SelectContent
              style={{
                backgroundColor: skin.bgColor,
                color: skin.textColor
              }}
            >
              {musicalKeyOptions.map((k) => (
                <SelectItem value={k} key={k}>
                  {k}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        {disableKeySelector ? null : (
          <button title="Reset Key" className="pl-2" onClick={resetKey}>
            <FiRotateCcw />
          </button>
        )}
      </div>
    </div>
  )
}

export default KeySelector
